const FACULTY_ONLY = "Faculty";
const NONE = "None";
export {
    FACULTY_ONLY,
    NONE
}